import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { environment } from "../../../environments/environment";
import { Response } from '../models';
import { LoginCredentials } from "../models/login-credentials.model";

@Injectable({ providedIn: 'root' })
export class LoginService {
	constructor(private http: HttpClient) { }

	login(user: LoginCredentials): Observable<Response<string>> {
		return this.http.post(`${environment.apiEndpoint}/Login`, user, { withCredentials: true });
	}

	requestNewPassword(username: any): Observable<Response<string>> {
		return this.http.put<Response<string>>(`${environment.apiEndpoint}/login/forgot-password`, { username });
	}
}